import { type ReactNode } from 'react';
import { HoverTooltip } from './HoverTooltip';
import { ReasonRows } from './ReasonRows';

export interface IReasonsTooltipProps {
  reasons: string[];
  children: ReactNode;
}

/**
 * Hover popup that lists every risk reason (translated). Used when a risk has
 * more reasons than fit on the card, where the label shows "primary +N" and the
 * hover reveals the full set. Reuses the dependency tooltip's navy popup style.
 */
export function ReasonsTooltip({ reasons, children }: IReasonsTooltipProps) {
  if (reasons.length === 0) return <>{children}</>;
  return <HoverTooltip content={<ReasonRows reasons={reasons} />}>{children}</HoverTooltip>;
}
